import IconContainer, { IconContainerProps } from "./IconContainer";

export default function IconVideo(props: IconContainerProps) {
    return <IconContainer {...props}>
        play_circle
    </IconContainer>
}